/**
 * Resolver for modules where module_element and module_link should not be tracked.
 */
const DEFAULT_RESOLVER = () => ({
    moduleElement: undefined,
    moduleLink: undefined
})

const resolvers = {
    'leap-copy-only': (props) => ({
        moduleElement: 'N/A',
        moduleLink: resolveModuleLink(props.primaryCta?.action)
    }),
    'leap-collage': (props) => ({
        moduleElement: 'N/A',
        moduleLink: resolveModuleLink(props.firstCta?.action)
    }),
    'leap-hero': (props) => ({
        moduleElement: resolveAssetType(
            props.assetDesktop.type ? props.assetDesktop.type : props.assetMobile.type
        ),
        moduleLink: resolveModuleLink(props.primaryCta?.action)
    }),
    'leap-media': (props) => ({
        moduleElement: resolveAssetType(props.asset?.type),
        moduleLink: 'N/A'
    }),
    'leap-highlights-stack': (props) => ({
        moduleElement: props.highlights[0]
            ? resolveAssetType(props.highlights[0].asset?.type)
            : 'N/A',
        moduleLink: props.highlights[0] ? resolveModuleLink(props.highlights[0].cta?.action) : 'N/A'
    }),
    'leap-campaign': (props) => ({
        moduleElement: resolveAssetType(props.assetImageVideo?.type),
        moduleLink: resolveModuleLink(props.firstCta?.action)
    }),

    'leap-teaser-list': DEFAULT_RESOLVER,
    'leap-product-animated': DEFAULT_RESOLVER,
    'leap-product-colors': DEFAULT_RESOLVER,
    'leap-awards': DEFAULT_RESOLVER,
    'leap-carousel': DEFAULT_RESOLVER,
    'leap-accordion': DEFAULT_RESOLVER,
    'leap-gallery': DEFAULT_RESOLVER,
    'leap-cards': DEFAULT_RESOLVER,
    'leap-overlay': DEFAULT_RESOLVER,
    'leap-comparison-table': DEFAULT_RESOLVER
}

/**
 * Extracts tracking data based on module type and props.
 * This function is to be used for tracking the new leap CMS modules.
 */
export const getModuleTrackingData = (type, props) => {
    const resolver = resolvers[type]

    if (!resolver) {
        throw new Error(
            `Tracking Error: Module type "${type}" is not defined in module-tracking-resolvers.js. ` +
                `Please add a resolver or explicitly set it to a "DEFAULT_RESOLVER" if tracking is not required.`
        )
    }

    return resolver(props)
}

const resolveAssetType = (type) => {
    if (type === undefined) return 'N/A'
    if (type === 'image') return 'image'
    if (type === 'brightcove') return 'video'
    return 'N/A'
}

const resolveModuleLink = (action) => {
    if (action?.value == null) return 'N/A'
    return action.value
}
